import React, { useState } from 'react'
import { useTranslation } from 'i18n'

import RichText from './RichText'
import * as styles from '../ImageEnhancement.module.scss'

/*
  PreviewStage: shows the generated image with download + share, a "view original" toggle,
  and a "try another (N left)" action that becomes an out-of-tries note once none remain.
*/
const PreviewStage = ({
  copy,
  cardClassName,
  resultUrl,
  originalUrl,
  remaining,
  canShare,
  onDownload,
  onRegenerate,
  onShare,
}) => {
  const { t } = useTranslation(['imageEnhancement', 'common'])
  const [showOriginal, setShowOriginal] = useState(false)
  const canRegenerate = remaining > 0

  return (
    <div className={cardClassName}>
      <div className={styles.cardHeader}>
        <RichText as="h2" className={styles.title} html={copy.previewTitle} />
        <RichText as="p" className={styles.subtitle} html={copy.previewSubtitle} />
      </div>

      <div className={styles.imageBox}>
        <img
          className={styles.resultImage}
          src={showOriginal && originalUrl ? originalUrl : resultUrl}
          alt={
            showOriginal
              ? t('imageEnhancement:originalPhotoAlt')
              : t('imageEnhancement:resultImageAlt')
          }
        />
        {!showOriginal && copy.previewDisclaimer && (
          <RichText className={styles.aiBadge} html={copy.previewDisclaimer} />
        )}
      </div>

      {originalUrl && (
        <button
          type="button"
          className={styles.toggle}
          role="switch"
          aria-checked={showOriginal}
          onClick={() => setShowOriginal(s => !s)}
        >
          <span className={`${styles.toggleTrack} ${showOriginal ? styles.toggleOn : ''}`}>
            <span className={styles.toggleThumb} />
          </span>
          {t('imageEnhancement:viewOriginalPhoto')}
        </button>
      )}

      <button type="button" className={styles.btn} onClick={onDownload}>
        {copy.downloadCtaText || t('imageEnhancement:downloadCta')}
      </button>

      {canShare && (
        <button type="button" className={styles.btnGhost} onClick={onShare}>
          {copy.shareCtaText || t('common:share')}
        </button>
      )}

      {canRegenerate ? (
        <button type="button" className={styles.btnGhost} onClick={onRegenerate}>
          {t('imageEnhancement:regenerateRemaining', {
            label: copy.regenerateCtaText || t('common:retry'),
            count: remaining,
          })}
        </button>
      ) : (
        <RichText className={styles.outOfTries} html={copy.outOfTriesText} />
      )}
    </div>
  )
}

export default PreviewStage
